//@flow

import React from "react"
import styled from "styled-components"
import { Spin } from "antd"

type Props = {
  style?: Object,
  spinStyle?: Object
}

const SpinWrap = styled.div`
  background: rgba(255, 255, 255, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding-top: 70px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
`

const LoadingSpin = ({ style, spinStyle }: Props): React$Element<any> => {
  return (
    <SpinWrap style={style}>
      <Spin style={spinStyle} />
    </SpinWrap>
  )
}

export default LoadingSpin
